import { AssignmentButton } from "../common/AssignmentButton";
import DetailItem from "./DetailItem";
import { Notification } from "../common/NotificationStatus";
import { StatusChip } from "../common/StatusChip";
import * as S from './styles/StatusDetailBar.style';
import { useTranslation } from '../../hooks/i18n/useTranslation';
import { StatusDetailBarProps } from './types';
import { isCaseReadOnlyStatus } from '../../services/api/flightChanges';

const StatusDetailBar = ({
    route,
    etd,
    pieces,
    notificationStatus,
    currentStatus,
    analyst,
    isAssigning,
    onAssign,
}: StatusDetailBarProps) => {
    const { t } = useTranslation();

    return (
        <S.Container>
            <DetailItem value={route} label={t("flightChangeDetails.route")} />
            <S.Divider />
            <DetailItem value={etd} label={t("flightChangeDetails.etd")} />
            <S.Divider />
            <DetailItem value={pieces.toString()} label={t("flightChangeDetails.pieces")} />
            <S.Divider />
            <Notification notificationStatus={notificationStatus} label={t("flightChangeDetails.notification")} />
            <S.Divider />
            <AssignmentButton
                analyst={analyst}
                isAssigning={isAssigning}
                onAssign={onAssign}
                showToAssignLink={true}
                isNotApplicable={isCaseReadOnlyStatus(currentStatus)}
            />
             <S.Divider />
            <StatusChip status={currentStatus} />
        </S.Container>
    );
};

export default StatusDetailBar;
